import React from "react";
import { Check, ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const benefits = ["Low-MOQ custom formulation & production.", "Precision counter-pressure canning line.", "FDA-registered & GMP-certified facility.", "Expertise in functional wellness RTDs.", "Full label & regulatory compliance support.", "Scalable pilot-to-production solutions.", "In-house lab for stability & shelf-life testing.", "Sleek aluminum can packaging specialists."];
  return <section data-section-id="12211" id="the-custom-rtd-edge" ref={ref} className={`py-24 px-6 bg-background text-foreground relative overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      {}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-30" />

      <div className="max-w-6xl mx-auto">
        {}
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tighter uppercase text-foreground mb-8">
            The Custom RTD Edge
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
            In the competitive landscape of functional beverages, your manufacturing partner is your greatest asset. We combine pharmaceutical-grade precision with beverage innovation, ensuring every can of probiotic fizz or adaptogen seltzer meets the highest standards of stability and taste. Our facility is engineered for the future of wellness, providing the technical edge required to scale your brand with total confidence.
          </p>
        </div>

        {}
        <div className="mb-16">
          <div className="text-center mb-10">
            <h3 className="text-sm font-medium text-primary uppercase tracking-widest font-mono">
              Engineering Excellence for Wellness Brands
            </h3>
          </div>

          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 max-w-4xl mx-auto">
            {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-4 p-4 rounded-lg hover:bg-accent/50 transition-colors duration-300">
                <div className="mt-1 shrink-0 bg-primary/10 p-1.5 rounded-full">
                  <Check className="w-5 h-5 text-primary stroke-[3]" />
                </div>
                <span className="text-base md:text-lg font-medium text-foreground font-sans">
                  {benefit}
                </span>
              </li>)}
          </ul>
        </div>

        {}
        <div className="max-w-4xl mx-auto mb-16">
          <Card className="bg-secondary/40 backdrop-blur-md border border-white/10 shadow-xl overflow-hidden relative group rounded-xl">
            {}
            <div className="absolute -right-20 -top-20 w-64 h-64 bg-primary/10 rounded-full blur-3xl group-hover:bg-primary/20 transition-all duration-700" />
            
            <CardContent className="p-8 md:p-12 text-center relative z-10">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 mb-6 text-primary">
                <ShieldCheck className="w-8 h-8" />
              </div>
              
              <h4 className="text-2xl md:text-3xl font-semibold text-foreground mb-4 uppercase tracking-tight">
                Technical Precision & Compliance
              </h4>
              
              <p className="text-muted-foreground text-lg leading-relaxed max-w-2xl mx-auto font-sans">
                From initial recipe development to final pack-out, our processes are rooted in rigorous quality control. We navigate the complexities of FDA regulations and label compliance so you can focus on growing your market presence.
              </p>
            </CardContent>
          </Card>
        </div>

        {}
        <div className="text-center">
          <Button asChild size="lg" className="bg-gradient-to-br from-primary to-primary/80 hover:from-primary/90 hover:to-primary text-primary-foreground font-bold text-lg px-10 py-7 rounded-full shadow-lg hover:shadow-primary/20 hover:-translate-y-1 transition-all duration-300 border-none">
            <Link to="/ContactPage" className="flex items-center gap-2">
              Start Your Formulation
              <ArrowRight className="w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}